module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-site.9040fa2f.jpg";